import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';

import { useExecutionConfig } from '@/features/decisions/hooks/useExecutionConfig';

interface RunConfigDialogProps {
  scenarioRunId: string;
  runId: string;
  open: boolean;
  onClose: () => void;
}

export function RunConfigDialog({ scenarioRunId, runId, open, onClose }: RunConfigDialogProps) {
  const { data, isPending, isError, error } = useExecutionConfig(scenarioRunId, runId, open);

  const body = () => {
    if (isPending) return 'Loading config…';
    if (isError) return `Could not load this run's config. ${error.message}`;
    return JSON.stringify(data?.config_body ?? null, null, 2);
  };

  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/40" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="flex max-h-[85vh] w-full max-w-3xl flex-col overflow-hidden rounded-xl bg-white shadow-xl">
          <div className="flex items-start justify-between gap-3 border-b border-gray-200 px-5 py-4">
            <div>
              <DialogTitle className="text-[16px] font-semibold text-[#1A1C2E]">Run config</DialogTitle>
              <p className="mt-0.5 text-[12px] text-[#9295A5]">
                <span className="font-mono">{runId}</span>
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded p-1 text-[#9295A5] hover:bg-[#F1F5F9] hover:text-[#1A1C2E]"
              aria-label="Close"
            >
              <XMarkIcon className="size-5" />
            </button>
          </div>
          {/* The snapshot Execution Service stored, so this is what actually ran rather than
              what was requested. */}
          <pre className="flex-1 overflow-auto bg-[#0F172A] p-4 text-[11px] leading-relaxed text-[#E2E8F0]">
            {body()}
          </pre>
        </DialogPanel>
      </div>
    </Dialog>
  );
}
